import { composeParser } from '@library/http'
import { extractCoreData } from '@library/http/parsers'
import type {
  DeliveryInstruction,
  Order,
  ShippingAddress,
  ShippingAddressResponse,
  UpdatedCurrentUser,
} from './interfaces'
import { DELIVERY_INSTRUCTIONS } from './constants'

export const extractPendingOrders = composeParser(extractCoreData<Order[]>(), (orders: Order[]) =>
  orders.filter((o: Order) => o.state === 'pending'),
)

export const extractAddressData = composeParser(
  extractCoreData<ShippingAddressResponse>(),
  (data: ShippingAddressResponse): ShippingAddress => {
    const { name, companyname: companyName, deliveryInstructions, ...rest } = data.created
    const nameAndCompanyName = { companyName, name: name && name.length > 0 ? name : companyName }

    if (deliveryInstructions.indexOf('Neighbour:') === 0) {
      return {
        ...rest,
        ...nameAndCompanyName,
        deliveryInstructions: 'Neighbour',
        deliveryInstructionsCustom: (deliveryInstructions.split('Neighbour:')[1] || '').trim(),
      }
    }

    if (!DELIVERY_INSTRUCTIONS.includes(deliveryInstructions as DeliveryInstruction)) {
      return {
        ...rest,
        ...nameAndCompanyName,
        deliveryInstructions: 'Other',
        deliveryInstructionsCustom: deliveryInstructions,
      }
    }

    return { ...rest, ...nameAndCompanyName, deliveryInstructions }
  },
)

export const extractUserResponse = composeParser(
  extractCoreData<UpdatedCurrentUser>(),
  (data: UpdatedCurrentUser) => ({
    user: {
      ...data.updated,
    },
  }),
)

export const extractEmptyResponse = async (resp: Response) => {
  if (resp.status >= 400) {
    throw new Error(resp.statusText)
  }
}
